import type { Site } from '../Site';

export const PCPro: Site = {
  id: 'pcpro',
  analyticsName: 'pcpro',
  selector: '',
  logo: '',
  label: 'PC Pro',
  platform: '',
};
